import React, { RefObject } from 'react';
import {
  GridComponent,
  ColumnDirective,
  ColumnsDirective,
  Inject,
  PdfExport,
} from '@syncfusion/ej2-react-grids';

interface ScheduleItem {
  startTime: string;
  endTime: string;
  patientName: string;
  physician?: string;
  roomId?: string;
  serviceCode?: string;
}

interface HiddenExportGridProps {
  transformedData: ScheduleItem[];
  gridRef: RefObject<GridComponent>;
}

export const HiddenExportGrid: React.FC<HiddenExportGridProps> = ({
  transformedData,
  gridRef,
}) => {
  if (transformedData.length === 0) return null;

  return (
    <div style={{ display: 'none' }}>
      <GridComponent
        ref={gridRef}
        dataSource={transformedData}
        allowPdfExport={true}
      >
        <ColumnsDirective>
          <ColumnDirective field='startTime' headerText='Start Time' width={120} />
          <ColumnDirective field='endTime' headerText='End Time' width={120} />
          <ColumnDirective field='patientName' headerText='Patient Name' width={150} />
          <ColumnDirective field='physician' headerText='Physician' width={120} />
          <ColumnDirective field='roomId' headerText='Room' width={80} />
          <ColumnDirective field='serviceCode' headerText='Service Code' width={100} />
        </ColumnsDirective>
        <Inject services={[PdfExport]} />
      </GridComponent>
    </div>
  );
};
